// Yup
import { object, array, number, string } from 'yup';

// Constants
import { CONST_LINES_OBJECT } from 'constants/lines';

const MIN_STOPS = 2;

const waySchema = object().shape({
  points: array().min(MIN_STOPS, `Insira pelo menos ${MIN_STOPS} pontos`),
  sections: array().of(
    object().shape({
      fare: object()
        .nullable()
        .required('Uma tarifa deve ser aplicada'),
      startStopId: string()
        .nullable()
        .required('Uma parada deve ser selecionada'),
      endStopId: string()
        .nullable()
        .required('Uma parada deve ser selecionada'),
    }),
  ),
});

const lineSchema = object().shape({
  general: object().shape({
    name: string().required('Campo nome obrigatório'),
    prefix: string().required('Campo prefixo obrigatório'),
    type: number().required('Campo modo obrigatório'),
    distributionType: number().required('Campo tipo de rede obrigatório'),
    lineType: number().required('Campo tipo de linha obrigatório'),
    lineFunction: number().required('Campo função da linha obrigatório'),
    model: number().required('Campo perfil tarifário obrigatório'),
    minVelocity: number().required('Obrigatório'),
    maxVelocity: number().required('Obrigatório'),
  }),
  paths: array().of(
    object().shape({
      name: string().required('Campo obrigatório'),
      go: waySchema,
      back: object().when('type', {
        is: CONST_LINES_OBJECT.PATH_TYPES.GO_BACK.KEY,
        then: waySchema,
      }),
    }),
  ),
});

export { lineSchema };
export default lineSchema;

// Legacy
/**
const MIN_STOPS = 2;

const lineSchema = object().shape({
  general: object().shape({
    name: string().required('Campo nome obrigatório'),
    prefix: string().required('Campo prefixo obrigatório'),
    type: number().required('Campo modo obrigatório'),
    distributionType: number().required('Campo tipo de rede obrigatório'),
    lineType: number().required('Campo tipo de linha obrigatório'),
    lineFunction: number().required('Campo função da linha obrigatório'),
    model: number().required('Campo perfil tarifário obrigatório'),
    minVelocity: number().required('Obrigatório'),
    maxVelocity: number().required('Obrigatório'),
  }),
  points: object().shape({
    going: array().min(MIN_STOPS, `Insira pelo menos ${MIN_STOPS} pontos.`),
    // return: array().min(MIN_STOPS, `Insira pelo menos ${MIN_STOPS} paradas.`),
  }),
  fares: object().shape({
    going: array().of(
      object().shape({
        pointStartId: string().required(
          'Um ponto de inicial deve ser aplicado',
        ),
        pointEndId: string().required('Um ponto de final deve ser aplicado'),
        fare: object()
          .nullable()
          .required('Uma tarifa deve ser aplicada'),
      }),
    ),
    return: array().of(
      object().shape({
        pointStartId: string().required(
          'Um ponto de inicial deve ser aplicado',
        ),
        pointEndId: string().required('Um ponto de final deve ser aplicado'),
        fare: object()
          .nullable()
          .required('Uma tarifa deve ser aplicada'),
      }),
    ),
  }),
}); */
